import { c as _c } from "react/compiler-runtime";
import React from 'react';
import ConfirmationModal from 'shared/components/confirmation-modal';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
interface ResendSenderEmailAddressModalProps {
  onResend: () => Promise<void>;
  opened: boolean;
  onClose: () => void;
}
function ResendSenderEmailAddressModal(t0) {
  const $ = _c(12);
  const {
    onResend,
    opened,
    onClose
  } = t0;
  const {
    t
  } = useLocoTranslation();
  let t1;
  if ($[0] !== onResend) {
    t1 = async () => {
      await onResend();
    };
    $[0] = onResend;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const handleConfirm = t1;
  let t2;
  if ($[2] !== t) {
    t2 = t("dashboard.settings.mailing.sender_email.resend_modal.title");
    $[2] = t;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t) {
    t3 = t("confirmation_modal.default_title");
    $[4] = t;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== handleConfirm || $[7] !== onClose || $[8] !== opened || $[9] !== t2 || $[10] !== t3) {
    t4 = <ConfirmationModal opened={opened} onClose={onClose} onConfirm={handleConfirm} confirmationText={t2} title={t3} />;
    $[6] = handleConfirm;
    $[7] = onClose;
    $[8] = opened;
    $[9] = t2;
    $[10] = t3;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  return t4;
}
export default ResendSenderEmailAddressModal;